/* frontend/src/pages/LessorEdit.js */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import LessorCreate from './LessorCreate';
import api from '../api';

// Shadcn UI components
import { Spinner } from '../components/ui/spinner';

export default function LessorEdit() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [defaults, setDefaults] = useState(null);

  useEffect(() => {
    api.get(`/locadoras/${id}`).then(r => setDefaults(r.data));
  }, [id]);

  /* ---------- carregando ---------- */
  if (!defaults) {
    return (
      <div className="container mx-auto px-4 mt-4 mb-6">
        <div className="min-h-[400px] flex flex-col items-center justify-center gap-4 bg-background border rounded-lg p-6">
          <Spinner className="h-10 w-10 text-primary" />
          <p className="text-muted-foreground">
            {t('lessor.detail.loading')}
          </p>
        </div>
      </div>
    );
  }

  /* ---------- modo edição ---------- */
  return <LessorCreate mode="edit" defaults={defaults} id={id} />;
}
